/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.battle-start", function(args){
        if(args.opr == 'split'){
            return true;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console", {value: "call DisplayComponent/event.start-game"});
            args.tweener
            .call(function(_args){
                _args.scene.addChild(BattleScene.BattleStart({
                }).setPosition(0,0));
            }, null, [args])
            .wait(2000);
        }
    });
    
    April.define("log.next-turn", function(args){
        if(args.opr == 'split'){
            return true;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console", {value: "call DisplayComponent/event.next-turn"});
            args.tweener
            .call(function(_args){
                _args.scene.addChild(BattleScene.NextTurn({
                    value: _args.turn,
                }).setPosition(0,0));
            }, null, [args])
            .wait(2000);
        }
    });
    
    April.define("log.action-start", function(args){
        if(args.opr == 'split'){
            return true;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
            var ch = args.scene.member[args.player];
            if(ch.actf){ ch.actf.remove(); }
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value:"call DisplayComponent/event.action"});
            //TODO 臨時
            args.tweener
            .call(function(_args){
              ch.actf=phina.display.RectangleShape({
                width:200, height:50,
                stroke:'black', fill:'white',
              }).addChildTo(ch).setPosition(250*ch.reverse,0);
              phina.display.Label({
                width:200, height:50,
                text:_args.action, fill:'black',
                align:'center', fontSize:20,
              }).addChildTo(ch.actf)
    //        	ch.actf=march.display.Fukidashi({
    //        		width:200, height:50,
    //        		text:_args.action_name, fontSize:20,
    //            stroke:'#2e2614', fill:'#FFF', strokeWidth: 10,
    //        	}).addChildTo(ch)
    //        	.setPosition(250*ch.reverse,0)
            }, null, [args])
            .wait(250)
        }
    });
    
    April.define("log.passive-start", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value:"call passive-start"});
            //TODO 臨時
            args.tweener
            .call(function(_args){
              phina.display.Label({
                width:200, height:50,
                text:_args.action, fill:'#FFF', 
                stroke:'#000', strokeWidth:2,
                align:'center', fontSize:20,
              }).setPosition(20,-20)
              .addChildTo(ch)
              .tweener
                .wait(1000)
                .fadeOut(100)
                .call(function(){ this.remove(); });
            }, null, [args])
        }
    });

    April.define("log.action-end", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            var ch = args.scene.member[args.player];
            if(ch.actf){ ch.actf.remove(); }
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value:"call DisplayComponent/event.after-action"});
            args.tweener
            .wait(250)
            .call(function(_args){
                if(ch.actf){ ch.actf.remove(); }
            }, null, [args]);
        }
    });
    
    April.define("DisplayComponent/event.rush", function(args){
      if(args.opr == 'split'){
          return false;
      }else if(args.opr == 'next'){
      }else if(args.opr == 'back'){
      }else if(args.opr == 'play'){
          var scene=args.scene;
          var ch = args.scene.member[args.player];
          scene.flare("act_console", {value: "call DisplayComponent/event.rush"});
          args.tweener
              .call(function(_args){
                  WaveEffect({
                    width:100,height:100,
                  }).addChildTo(ch).setPosition(0,0);
              }, null, [args]);
      }
    });
    
    April.define("log.down", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
          var ch = args.scene.member[args.player];
          ch.live=false;
        }else if(args.opr == 'back'){
          var ch = args.scene.member[args.player];
          ch.live=true;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value:"call DisplayComponent/event.died-character"});
            args.tweener
            .call(function(_args){
                BattleScene.Fukidasi("img/ui/F_hunou.png", 110, 55)
                .addChildTo(ch).setPosition(0,0);
            }, null, [args])
            .wait(2000)
            .call(function(_args){
              ch.live = false;
            }, null, [args]);
        }
    });
    
    April.define("log.battle-end", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            var scene=args.scene;
            if(!scene.endgame){
              scene.endgame = BattleScene.EndGame({
                scene: scene,
                role: args.role,
              }).setPosition(0,0);
              scene.addChild(scene.endgame);
            }
        }else if(args.opr == 'back'){
            var scene=args.scene;
            scene.endgame.remove();
            delete scene.endgame;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console", {value:"call DisplayComponent/event.end-game"});
            args.tweener
            .call(function(_args){
                _args.scene.endgame = BattleScene.EndGame({
                  scene: scene,
                  role: _args.role,
                }).setPosition(0,0);
                _args.scene.addChild(_args.scene.endgame);
            }, null, [args])
        }
    });    
}
